import '../../assets/styles/auth.scss'
import '../../assets/styles/pages.scss'
import { Link, useLocation, useMatch, useNavigate } from 'react-router-dom'
import DownloadFileModal from '../../components/common/download-file-modal'
import { useContext, useEffect, useState } from 'react'
import henceforthApi, { Redirect_User_URL } from '../../utils/henceforthApi'
import PaginationLayout from '../../components/PaginationLayout'
import { GlobalContext, handleError } from '../../context/Provider'
import moment from 'moment'
import Spinner from '../../components/BootstrapCompo'
import { toast } from 'react-toastify'
import profile_placeholder from '../../assets/images/pages/profile_placeholder.png'
import BreadCrumb from '../../components/common/BreadCrumb'
import { INSUFFICIENT_PERMISSIONS } from '../../context/actionTypes'
import SignedImage from '../../components/SignedImage'
import SortIcon from "../../components/common/SortIcon";


const UserListing = () => {
    let breadCrumbPath = [
        { name: 'Home', url: `/`, active: '' },
        { name: 'User list', url: ``, active: 'not-allowed' }
    ]
    const navigate = useNavigate();
    const location = useLocation();
    const { authState, onChangePagination, loading, setLoading } = useContext(GlobalContext);

    const [pageData, setpageData] = useState<any[]>([])
    const newParam = new URLSearchParams(location.search);
    const match: any = useMatch("/users/:page")
    let limit = 10;
    const [searchData, setSearchData] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const sortField = newParam.get("sort_by") || "";
    const sortOrder = newParam.get("sort_order") || "asc";

    const onSort = (field: string, order: "asc" | "desc") => {
        const params = new URLSearchParams(location.search);

        params.set("sort_by", field);
        params.set("sort_order", order);

        if (newParam.get("search"))
            params.set("search", newParam.get("search")!);

        if (newParam.get("filter"))
            params.set("filter", newParam.get("filter")!);

        navigate(`/users/${match.params.page}?${params.toString()}`);
    };
    const onSearch = async (searchData: any) => {
        const currentFilter = newParam.get("filter");
        const params = new URLSearchParams();
        if (searchData) {
            params.set("search", searchData);
        }
        if (currentFilter) {
            params.set("filter", currentFilter);
        }
        const queryString = params.toString();
        if (queryString) {
            navigate(`/users/1?${queryString}`);
        } else {
            navigate(`/users/1`);
        }
    };
    const changeGraphType = (type: any) => {
        const newParam = new URLSearchParams()
        if (type) {
            newParam.set("filter", type)
        }
        navigate({ search: newParam.toString() })
    }
    const initialise = async () => {
        setLoading(true)
        let searchData = newParam.has("search") ? newParam.get("search") : null;
        setSearchData(searchData as any);
        try {
            let q = newParam.get("filter")
            let apires = await henceforthApi.User.getlisting(
                searchData,
                q,
                Number(match.params.page)-1 ,
                limit,
                sortField,
                sortOrder
            )
            toast.success(apires.message)
            setpageData(apires.data)
            setTotalCount(apires.total_count);
        } catch (error: any) {
            if (error?.response?.body?.error === INSUFFICIENT_PERMISSIONS) {
                window.history.back()
            }
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        initialise()
    }, [match.params.page, newParam.get("search"), newParam.get("filter"), newParam.get("sort_by"), newParam.get("sort_order"), authState?.lang])

    const exportData = async (startDate: number, endDate: number) => {
        try {
            const apiRes = await henceforthApi.User.getexport(startDate, endDate)
            const data = apiRes.data
            const rows = [
                [
                    "Sr.no",
                    "Name",
                    "Email",
                    "Phone Number",
                ],
            ];
            if (Array.isArray(data)) {
                data.map((res: any, index: any) => {
                    rows.push([
                        index + 1,
                        res.name,
                        res.email,
                        res.phone_no,
                    ])
                })
            }
            // debugger
            let csvContent =
                "data:text/csv;charset=utf-8," +
                rows.map((e) => e.join(",")).join("\n");
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `user_${moment().valueOf()}.csv`);
            document.body.appendChild(link);
            link.click();
            let closeModal = document.getElementById("closeModal");
            if (closeModal) {
                closeModal.click();
            }
            // debugger
        } catch (error) {
            handleError(error)
        }
    }

    // const SortIcon = ({ field }: { field: string }) => (
    //     <span
    //         className="ms-1"
    //         style={{
    //             cursor: "pointer",
    //             display: "inline-flex",
    //             gap: "4px",
    //             verticalAlign: "middle",
    //         }}
    //         onClick={() => onSort(field)}
    //     >
    //         <i
    //             className="fa fa-arrow-up"
    //             style={{
    //                 fontSize: "13px",
    //                 color:
    //                     sortField === field &&
    //                         sortOrder === "asc"
    //                         ? "#29ABE2"
    //                         : "#b0b8c1",
    //             }}
    //         />

    //         <i
    //             className="fa fa-arrow-down"
    //             style={{
    //                 fontSize: "13px",
    //                 color:
    //                     sortField === field &&
    //                         sortOrder === "desc"
    //                         ? "#e03131"
    //                         : "#b0b8c1",
    //             }}
    //         />
    //     </span>
    // );
    return (
        <>
            {/* breadcrum  */}

            <BreadCrumb pathNameDeclare={breadCrumbPath} />

            {/* page  */}
            <div className='page-spacing'>
                <section className='product-listing'>
                    <div className="product-detail-box">
                        <div className='common-card mb-4 border-0 card-spacing'>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row gy-3">
                                        {/* serach and filter  */}
                                        <div className="col-md-7">
                                            <div className='form-fields-box'>
                                                <label className='mb-1 form-label fw-semibold'>Search</label>
                                                <div className='position-relative'>
                                                    <input type="search" value={searchData || ''} className="form-control rounded-0 ps-4 " placeholder="Search by Name, Email"
                                                        onChange={(e: any) => {
                                                            setSearchData(e.target.value);
                                                            onSearch(e.target.value);
                                                        }}
                                                    />
                                                    <span className='search-icon'><i className='fa fa-search'></i></span>
                                                </div>
                                            </div>
                                        </div>
                                        {/* filter */}
                                        <div className="col-md-5">
                                            <div className='form-select-box'>
                                                <label className='mb-1 form-label fw-semibold'>Filter</label>
                                                <select className="form-select shadow-none" aria-label="Default select example"
                                                    onChange={(e) => changeGraphType(String(e.target.value))} value={String(newParam.get("filter")).toUpperCase()} >
                                                    <option value="ACTIVE_USERS">ACTIVE USERS</option>
                                                    <option value="BLOCKED_USERS">BLOCKED USERS</option>
                                                    <option value="DEACTIVE_USERS">DEACTIVE USERS</option>
                                                </select>
                                            </div></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* table  */}
                        <div className="row">
                            <div className="col-md-12">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <h5>User List</h5>
                                        </div>
                                    </div>
                                    <div className="common-card-content">
                                        <div className="mt-4">
                                            {loading ? <div className='d-flex justifly-content-center'><Spinner /> </div> :
                                                <div>
                                                    {/* table */}
                                                    <div className='data-list-table table-responsive mb-3'>
                                                        <table className="table table-striped align-middle">
                                                            <thead className=''>
                                                                <tr>
                                                                    <th>Sr.no</th>
                                                                    <th>
                                                                        Name
                                                                        <SortIcon column={"name"} activeColumn={sortField} direction={sortOrder as any} onChange={onSort} />
                                                                    </th>

                                                                    <th>
                                                                        Email
                                                                        <SortIcon column={"email"} activeColumn={sortField} direction={sortOrder as any} onChange={onSort} />
                                                                    </th>

                                                                    <th>
                                                                        Phone Number
                                                                        <SortIcon column={"phone_no"} activeColumn={sortField} direction={sortOrder as any} onChange={onSort} />
                                                                    </th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {Array.isArray(pageData) && pageData.length ? pageData.map((res, index) =>
                                                                    <tr key={res.id}>
                                                                        <td>
                                                                            {match.params.page == 0
                                                                                ? index + 1
                                                                                : (match.params.page - 1) * limit + (index + 1)}
                                                                        </td>
                                                                        <td className='product-image-table'>
                                                                            <SignedImage
                                                                                src={res.profile_pic || ""}
                                                                                fallback={profile_placeholder}
                                                                                alt="img"
                                                                                className='rounded-circle me-2'
                                                                                size="small"
                                                                            />
                                                                            {res.name ? `${res.name} ` : `Not Available`}
                                                                        </td>
                                                                        <td>{res.email ? `${res.email}` : 'Not Available'}</td>
                                                                        <td>{res.phone_no ? `+${res.country_code}-${res.phone_no}` : 'Not Available'}</td>
                                                                        <td><div className="btn-group gap-2">
                                                                            <Link to={`/user/${res._id}`} className="btn btn-white btn-sm"> <i className='fa fa-eye me-1'></i>View</Link>
                                                                            {
                                                                                (newParam.get("filter") !== "BLOCKED_USERS" && newParam.get("filter") !== "DEACTIVE_USERS") && (
                                                                                    <a className="btn btn-white btn-sm text-decoration-none" href={`${Redirect_User_URL}signin?user_key=${encodeURIComponent(res._id)}&access_token=${authState.access_token}`} target="_blank" >
                                                                                        <i className='fa fa-sign-in me-1'></i>Login as user
                                                                                    </a>
                                                                                )
                                                                            }
                                                                        </div>
                                                                        </td>
                                                                    </tr>) : <tr><td colSpan={9} className="text-center">No data found</td></tr>}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {/* pagination  */}
                                                    <div className='dashboad-pagination-box'>
                                                        <PaginationLayout
                                                            count={totalCount}
                                                            data={pageData}
                                                            page={Number(match.params.page)}
                                                            limit={Number(limit)}
                                                            // loading={load}
                                                            onPageChange={(val: any) => onChangePagination(val)}

                                                        />
                                                    </div>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div>
            <DownloadFileModal exportData={exportData} />
        </>
    )
}
export default UserListing;